import { KnownSortOrder, KnownUserStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import dayjs from 'dayjs';
import { ListPageHeaderProps } from '../../../../ui/components/pure/page-headers/list/list-page-header.component';
import { CouriersListControlsState, CouriersListQueryInput } from '../../list/logic/couriers-list-query.map';

/** Status is fixed and every carrier is a phone group, so neither is a control. */
export type IncompleteCouriersControlsState = Pick<CouriersListControlsState, 'sortBy' | 'sortOrder' | 'searchTerm'>;

// Newest first: incomplete couriers have no name to sort by.
export const initialIncompleteCouriersControlsState: IncompleteCouriersControlsState = {
  sortBy: 'createdTime',
  sortOrder: KnownSortOrder.Desc,
  searchTerm: ''
};

export const INCOMPLETE_COURIERS_WINDOW_DAYS = 14;

export const INCOMPLETE_COURIERS_EMPTY_MESSAGE = 'No incomplete couriers to action.';

/** Start of day, so the query key stays stable all day. */
export function incompleteCouriersWindowStart(now: Date = new Date()): Date {
  return dayjs(now).subtract(INCOMPLETE_COURIERS_WINDOW_DAYS, 'day').startOf('day').toDate();
}

/**
 * Filters on updated time as the endpoint has no created filter. They match for incomplete
 * couriers, as nothing updates them until they're completed or deactivated.
 */
export function makeIncompleteCouriersQueryInput(
  controls: Partial<IncompleteCouriersControlsState>,
  now: Date = new Date()
): CouriersListQueryInput {
  return { ...controls, status: KnownUserStatus.Incomplete, updatedFrom: incompleteCouriersWindowStart(now) };
}

export function makeIncompleteCouriersPageHeaderProps(
  couriersCount: number,
  form: IncompleteCouriersControlsState,
  onFormInput: (update: Partial<IncompleteCouriersControlsState>) => void
): ListPageHeaderProps<IncompleteCouriersControlsState> {
  return {
    title: 'Incomplete Couriers',
    subtitle: `${couriersCount} ${couriersCount === 1 ? 'Courier' : 'Couriers'}`,
    controls: {
      form,
      onFormInput,
      inputs: [
        {
          type: 'text',
          label: 'Search by mobile',
          field: 'searchTerm'
        }
      ]
    }
  };
}
